export const initialState = {
    gameSocketError: null,
    isGameSocketError: false,
    chatSocketError: null,
    isChatSocketError: false,
  };